import axios from 'axios';
import _, { isEmpty } from 'lodash';

import store from '../store';
import { reportToSentry } from '../utils/reportToSentry';
import { getAppVersion } from '../utils/version/getVersion';
import { setCriticalError } from '../sagas/layout/actions';
import { API_URL } from '../config';

const criticalErrors = [401, 404, 500, 501, 502, 503, 504];

export const handleErrors = ({ error, putErrorData, onError, handledErrors, endpoint, suppressCriticalErrors = [] }) => {
  const response = error.response;
  const exceptPaths = ['signin', 'signup', 'password-reset', 'password-reset-sent', 'accept-invitation'];

  if (!axios.isCancel(error)){
    if (response) {
      if (response.status) {
        if (!exceptPaths.some(path => window.location.pathname.includes(path))) {
          const isCriticalError = criticalErrors.indexOf(response.status) !== -1;
          const isSuppressedCriticalError = suppressCriticalErrors.indexOf(response.status) !== -1;

          if (isCriticalError && !isSuppressedCriticalError) {
            store.dispatch(setCriticalError(response));
          }
        }
      }

      if (response.data || (response.status === 404)) {
        const responseErrors = response?.data?.errors || {};

        store.dispatch(putErrorData(responseErrors, error));
        onError && onError(responseErrors, error);

        const unhandledErrors = _.omit(responseErrors, handledErrors || []);

        if (!isEmpty(unhandledErrors) && response.status !== 404) reportToSentry(unhandledErrors, error, endpoint);
      }
    } else {
      if (!exceptPaths.some(path => window.location.pathname.includes(path))) {
        store.dispatch(setCriticalError({ status: 'unknown' }));
      }
    }
  }
};

const getRequestHeaders = (pub, multipart) => {
  const { api_token } = store.getState().authData;

  return {
    'Content-Type': !multipart ? 'application/json' : 'multipart/form-data',
    'X-APP-VERSION': getAppVersion(),
    'X-APP': 'BussinessWebApp',
    ...(api_token && !pub) && { 'X-API-TOKEN': api_token }
  };
};

const applyPathParams = (url, pathParams = {}) => Object.entries(pathParams).reduce(
  (currentUrl, [key, value]) => currentUrl.split(`:${key}`).join(value),
  url
);

export const fetch = async ({
  api,
  url,
  data,
  params,
  id,
  uuid,
  pathParams,
  pub = false,
  multipart = false,
  signal,
  useV1 = false
}) => {
  const requestPathParams = {
    ...(id !== undefined && id !== null) && { id },
    ...(uuid !== undefined && uuid !== null) && { uuid },
    ...(pathParams || {})
  };

  const requestUrl = applyPathParams(api.url, requestPathParams);

  return await axios({
    method: api.method,
    // `url` is an absolute URL handed back by the API (e.g. a paginated response's `next`) - use it as-is
    url: url || (!useV1 ? `${API_URL}v2${requestUrl}` : `${API_URL}v1${requestUrl}`),
    headers: getRequestHeaders(pub, multipart),
    ...(signal && { signal }),
    ...(data && { data }),
    ...(params && { params })
  });
};
